/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { META_DESCRIPTION, META_KEYWORDS } from '../constants'

function Seo({ description, keywords, lang }) {
  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      meta={[
        {
          name: `description`,
          content: description
        },
        {
          name: `keywords`,
          content: keywords
        }
      ]}
    />
  )
}

Seo.defaultProps = {
  description: META_DESCRIPTION,
  keywords: META_KEYWORDS,
  lang: `en`
}

Seo.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.string,
  lang: PropTypes.string
}

export default React.memo(Seo)
